import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { calculateOverlay } from "../../../utils";

var BannerOverlayInlineStyles = /*#__PURE__*/function () {
  function BannerOverlayInlineStyles() {
    _classCallCheck(this, BannerOverlayInlineStyles);
  }

  _createClass(BannerOverlayInlineStyles, null, [{
    key: "overlay",

    /**
     * This method needs to be ported to Banner.php#wp_footer, too!
     */
    value: function overlay(_ref) {
      var _ref$layout = _ref.layout,
          type = _ref$layout.type,
          _overlay = _ref$layout.overlay,
          overlayBg = _ref$layout.overlayBg,
          overlayBgAlpha = _ref$layout.overlayBgAlpha,
          fontSize = _ref.design.fontSize,
          antiAdBlocker = _ref.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-bann3r rcb-bann3r-".concat(type, " ").concat(_overlay ? "" : "overlay-deactivated"),
        style: {
          background: _overlay ? calculateOverlay(overlayBg, overlayBgAlpha) : "none",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 99999,
          pointerEvents: _overlay ? "all" : "none",
          fontSize: +fontSize
        }
      };
    }
  }, {
    key: "alignment",
    value: function alignment(_ref2) {
      var _ref2$layout = _ref2.layout,
          type = _ref2$layout.type,
          dialogPosition = _ref2$layout.dialogPosition,
          antiAdBlocker = _ref2.customCss.antiAdBlocker;
      var style = {
        display: "flex",
        width: "100%",
        height: "100%"
      };

      if (type === "dialog") {
        style.alignItems = dialogPosition.startsWith("top") ? "flex-start" : dialogPosition.startsWith("bottom") ? "flex-end" : "center";
        style.justifyContent = dialogPosition.endsWith("Center") ? "center" : dialogPosition.endsWith("Left") ? "flex-start" : "flex-end";
      }

      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-align",
        style: style
      };
    }
  }]);

  return BannerOverlayInlineStyles;
}();

export { BannerOverlayInlineStyles };